<template>
  <v-container>
    <Loader :esActiva="mostrar_loader"/>

    <FormRegistrarse />

    <v-row class="d-flex justify-center mt-6  pb-3"  >      
        <v-checkbox
        v-model="usuario.terminos"
        ></v-checkbox>
        <p style="color:#515C6F; font-size: 12px;" class="mt-3 ml-2" >
          Al crear una cuenta, usted acepta nuestros
          <br />
          <a
            target="_blank"
            href="https://reponerya.com.uy/aviso-privacidad"
            style="color:#58C4B5; font-size: 12px; margin-left: -1px;"
          >Aviso de privacidad</a>
        </p>      
    </v-row>

    <v-radio-group
      v-if="!usuario.login_social"
      class="mt-0 pt-0  "
      v-model="usuario.validacion"
      row
    > <v-col cols="6" class="d-flex justify-center">
      <v-radio
        label="Verificar vía correo electrónico"
        value="correo"
      ></v-radio>
      </v-col>
      <v-col cols="6" class="d-flex justify-center">
      <v-radio
        label="Verificar vía SMS"
        value="sms"
      ></v-radio>
      </v-col>
    </v-radio-group>      
    <br>
    <v-footer absolute class="font-weight-medium" padless>
      <v-btn x-large color="#58C4B5" dark style="width: 100%;" :style="{ 'opacity': `${opacidad}`}"
      @click="submit()" >REGISTRAR</v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import Vista from "@/objetos/vista";
import Usuario from "@/objetos/usuario";
import FormRegistrarse from "@/components/Registrarse/FormRegistrarse";
import Snackbar from "@/objetos/snackbar";
import Loader from '@/components/Loader/Loader.vue';
import Conexion_api from "@/api/Conexion_api.js";
import registrar_contacto from "@/funciones/registrar_contacto.js"
import datos_registro from "@/objetos/datos_registro"

export default {
  components: {
    FormRegistrarse,
    Loader
  },
  data: () => ({
    alert: true,
    usuario: Usuario,
    icon_alert: "",
    color_alert: "",
    social: "",
    snackbar: Snackbar,
    mostrar_loader: false,
    datos_registro: null,
    so: ""
  }),
  mounted() {
    if(this.usuario.login_social) this.usuario.validacion = "none"
    Vista.nombre = "/registrarse";
    setTimeout(() => {
      this.alert = false;
    }, 3000);
    this.$root.$on("estatus_loader", (estatus) => {
      this.mostrar_loader = estatus
    });    
  },
  computed: {
    opacidad: function () {
      if (this.usuario.valido){
          return 1;
      }
      return 0.7
    }
  },  
  methods: {
    submit() {
      this.$root.$emit("registrar_usuario");
      if(this.usuario.valido && this.usuario.terminos && this.usuario.validacion){
        this.mostrar_loader = true
        const fecha = new Date();
        const fecha_registro = `${fecha.getFullYear()}/${fecha.getMonth()+1}/${fecha.getDate()} ${fecha.getHours()}:${fecha.getMinutes()}:${fecha.getSeconds()}`
        const navInfo = window.navigator.userAgent.toLowerCase();
        this.retornarSO(navInfo);
        Conexion_api({
          body: {
              ...this.usuario,
              fecha_registro: fecha_registro,
              sistema_operativo: this.so
          },
          evento: "login/registrar_usuario"
        })
        .then(respuesta => { 
            this.mostrar_loader = false              
            if (respuesta.data.error) {
                console.error(respuesta.data.error);
                this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})   
                return;
            }
            if(this.usuario.login_social){
              
              if(this.usuario.rut) {
                datos_registro.telefono = this.usuario.telefono
                datos_registro.correo = this.usuario.correo
                datos_registro.rut = this.usuario.rut
                datos_registro.nuevo_registro = true
                datos_registro.coordenadas = this.usuario.coordenadas
                registrar_contacto(datos_registro);
              }

              this.$cookie.set('pwst', respuesta.data.token, { expires: '1h' });
              this.$router.push("/distribuidor")
              return
            }
            this.$router.push({ name: "Verificar código", params: { fecha_registro: fecha_registro, sistema_operativo: this.so} })
        })
        .catch(err => {
            this.mostrar_loader = false
            err = String(err);
            this.$root.$emit('snackbar',{ color:"error", texto: err})
            console.error(err);
        });
      }else{
        this.mostrar_loader = false
        
        var err= "";
        if(!this.usuario.terminos){
          err = "Debe confirmar los términos antes de continuar"
          this.$root.$emit('snackbar',{ color:"error", texto: err})
          console.error(err); 
        }
        if(!this.usuario.validacion){          
            err = "Debe seleccionar un mecanismo de validación"
            this.$root.$emit('snackbar',{ color:"error", texto: err})
            console.error(err);
        }
        /*activar para validacion con debounce*/
        // if(!this.usuario.correo_valido){
        //     err = "Email invalido."
        //     this.$root.$emit('snackbar',{ color:"error", texto: err})
        //     console.error(err);
        // }
      }
    },
    retornarSO(navInfo){
      if(navInfo.indexOf('win') != -1){
        this.so = 'Windows';
      }
      else if(navInfo.indexOf('linux') != -1){
        this.so = 'Linux';
      }
      else if(navInfo.indexOf('mac') != -1){
        this.so = 'Mac';
      }
      else if(navInfo.indexOf('ios') != -1){
        this.so = 'IOS';
      }
      else if(navInfo.indexOf('android') != -1){
        this.so = 'Android';
      }else{
        this.so = 'Otro'
      }
    }
  }
}
</script>